// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__EETD-","header":"MergedInvoice_header__1tcl0"};